import { el } from './dom.js';
import { showToast } from './toast.js';

// ── Install prompt ───────────────────────────────────────────────

let deferredPrompt = null;
let bannerEl = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;

  if (localStorage.getItem('pwa-install-dismissed')) return;
  showInstallBanner();
});

function showInstallBanner() {
  if (bannerEl) return;

  bannerEl = el('div', { className: 'pwa-install-banner' },
    el('span', null, 'Install FictionFeed for offline use'),
    el('div', { style: { display: 'flex', gap: 'var(--space-sm)' } },
      el('button', {
        className: 'btn btn--primary btn--sm',
        onClick: handleInstall,
      }, 'Install'),
      el('button', {
        className: 'btn btn--ghost btn--sm',
        onClick: dismissBanner,
      }, 'Not now'),
    ),
  );

  document.body.appendChild(bannerEl);
  requestAnimationFrame(() => bannerEl.classList.add('pwa-install-banner--visible'));
}

async function handleInstall() {
  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  removeBanner();
  if (outcome === 'accepted') {
    showToast('FictionFeed installed!', { type: 'success' });
  }
}

function dismissBanner() {
  localStorage.setItem('pwa-install-dismissed', '1');
  removeBanner();
}

function removeBanner() {
  if (!bannerEl) return;
  bannerEl.classList.remove('pwa-install-banner--visible');
  bannerEl.addEventListener('transitionend', () => bannerEl.remove(), { once: true });
  setTimeout(() => { if (bannerEl?.parentNode) bannerEl.remove(); }, 300);
  bannerEl = null;
}

// ── SW update notification ───────────────────────────────────────

export function registerSW() {
  if (!('serviceWorker' in navigator)) return;

  // vite-plugin-pwa with registerType:'prompt' exposes this on window
  import('virtual:pwa-register').then(({ registerSW: register }) => {
    const updateSW = register({
      onNeedRefresh() {
        showUpdateToast(updateSW);
      },
      onOfflineReady() {
        showToast('App ready for offline use', { type: 'success' });
      },
    });
  });
}

function showUpdateToast(updateFn) {
  const toast = el('div', { className: 'toast toast--info pwa-update-toast' },
    el('span', null, 'New version available'),
    el('button', {
      className: 'btn btn--primary btn--sm',
      style: { marginLeft: 'var(--space-sm)' },
      onClick: () => {
        updateFn(true);
        toast.remove();
      },
    }, 'Reload'),
  );

  // Use toast container
  let container = document.querySelector('.toast-container');
  if (!container) {
    container = el('div', { className: 'toast-container' });
    document.body.appendChild(container);
  }
  container.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('toast--visible'));
}
